import { TabLink } from '@/routes/_app/admin/-components/TabLink.tsx'
import { Outlet, createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_app/admin')({
  component: RouteComponent,
  beforeLoad({ context }) {
    const { auth } = context
    if (auth.permissions.cannot('show', 'admin-section')) {
      throw redirect({
        to: '/',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { pathname } = useLocation()

  function handleSeatTab(tab: 'search-tokens' | 'tags' | 'users') {
    navigate({ to: tab })
  }

  const isActive = (tab: string) => pathname === `/admin/${tab}`

  useEffect(() => {
    if (pathname === '/admin') {
      navigate({ to: 'users' })
    }
  }, [pathname])

  return (
    <main>
      <div className="grid grid-cols-12">
        <nav className="col-span-2 p-2">
          <h2 className="text-3xl font-bold text-foreground">Administração</h2>

          <div className="mt-5 flex flex-col ">
            <TabLink isActive={isActive('users')} onClick={() => handleSeatTab('users')}>
              Usuários
            </TabLink>

            <TabLink isActive={isActive('search-tokens')} onClick={() => handleSeatTab('search-tokens')}>
              Tokens de busca
            </TabLink>

            <TabLink isActive={isActive('tags')} onClick={() => handleSeatTab('tags')}>
              Tags
            </TabLink>
          </div>
        </nav>

        <section className="col-span-10 size-full rounded-md border p-4">
          <Outlet />
        </section>
      </div>
    </main>
  )
}
